module.exports = __webpack_public_path__ + "static/media/Cats eyes 03_SPANSKA-mixdown.c859162a.mp3";